import { EventFlowTopic } from '@/model/event-flow/EventFlow';

export type Topic = {
    id: number | null;
    name: string | null;
    order: number | null;
};

export type PutTopicRequest = {
    topic: Topic;
    eventId: number;
};

export type PostTopicRequest = PutTopicRequest;

export type DeleteTopicRequest = {
    eventId: number;
    topicId: number | null;
};

export function createEmptyTopic(): Topic {
    return {
        id: 0,
        name: '',
        order: Infinity,
    };
}

export function createTopicFromEventFlowTopic(
    eventFlowTopic: EventFlowTopic,
): Topic {
    return {
        id: eventFlowTopic.id,
        name: eventFlowTopic.name,
        order: eventFlowTopic.order,
    };
}
